import { configureStore } from '@reduxjs/toolkit';

import { APP_ENV } from 'src/global/config/common.config';

import { middleware } from './middleware';
import { reducer } from './reducers';

// Hold the store instance so we can access it outside of React components
export let store: ReturnType<typeof makeStore> | null = null;

export const makeStore = () => {
  const _store = configureStore({
    reducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }).concat(middleware),
    devTools: APP_ENV !== 'production',
  });

  // `_store` to hold the return type of `configureStore`
  // then we can safely assign it to `store` variable
  store = _store;

  return _store;
};
